// US States for dropdown
export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

// Helper function to format duration
export const formatDuration = (minutes) => {
  // If the value is less than 10, assume it's stored as hours (e.g., 4 hours, 0.5 hours)
  // This handles the case where durations are stored as hours in the database
  if (minutes < 10) {
    const hours = minutes;
    if (hours === Math.floor(hours)) {
      return `${hours}h`;
    } else {
      return `${hours}h`;
    }
  }
  
  // Otherwise treat as minutes
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};
